<template lang="pug">
v-container(fluid data-test="results-page")
  portal(to='toolbar') 
    v-toolbar-title(data-test="slots-title") Reserved exams
  typeProvider(v-slot="typeProps")
    v-card
      .d-flex
        v-spacer
        v-radio-group(:value="typeProps.type" @change="typeProps.update" row hide-details).mt-0
          v-radio(:value="ACTIVE_TYPE.ALL" label="All exams")
          v-radio(:value="ACTIVE_TYPE.TOP" label="TOPCBR exams")
          v-radio(:value="ACTIVE_TYPE.MIJN" label="MIJNCBR exams")
      filters(
        @filterChanged="updateList"
      )
      list(
        :model="model"
        @loadMore="loadListMore"
        :loading="loading"
        :pagination="pagination"
        v-show="!loadingErr"
      ).pb-4
      .slots-error(v-show="loadingErr") {{ loadingErr }}
  
</template>

<script>
import {mapActions} from "vuex"

import Svc from "./core/reserved-service"
import ReservedModel from "./core/reserved-model"
import errorsMixin from '@/mixins/errors.mixin'
import ReservedLogModel from "./core/models/reservedLogModel"
import { LOG_PAGE, CRM_PERMS, VIEWPORTS } from '@/util/const'
import PaginationModel from "@/models/paginationModel"
import paginationMixin from '@/mixins/pagination.mixin'
import permsMixin from '@/mixins/perms.mixin'
import { ACTIVE_TYPE } from './core/reserved-const'

export default {
  mixins: [errorsMixin, paginationMixin, permsMixin],

  metaInfo: {
    meta: [
      { vmid: 'viewport-main', name: 'viewport', content: VIEWPORTS.DEFAULT }
    ]
  },

  data: () => ({
    svc: new Svc(),
    model: new ReservedModel(),
    loading: false,
    loadingErr: null,
    pagination: null,
    log: null,
    logShowing: false,
    ACTIVE_TYPE: ACTIVE_TYPE
  }),

  inject: ['perms'],

  created() {
    this.checkPerm(CRM_PERMS.RESERVED_EXAMS)
  },

  mounted() {
    this.getCbrUsers()
  },

  methods: {
    ...mapActions({
      getCbrUsers: 'cbrUser/list'
    }),


    updateList() {
      this.loadList({})
    },

    async loadListMore() {
      this.pagination.loadMore()
      await this.setPaginationQuery()
      this.loadList({more: true})
    },

    async loadList({more = false}) {
      try {
        this.loading = true
        this.loadingErr = null
        let res = await this.svc.list(this.$route.query)
        if(!more) {
          this.model.list = {}
          if(!Object.keys(res.results).length) this.loadingErr = 'According to your parameters, there are no exams. Try another date, time, location or day.'
        } 
        this.pagination = new PaginationModel(this.setPaginationParams(res.pagination))
        this.model.setList(res.results, this.$set)
        this.loading = false
      } catch (error) {
        this.loading = false
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

    loadLogs() {
      if(this.logShowing) {
        this.logShowing = false
        return
      }
      this.$refs.log.loadData({
        ...this.$refs.log.getDefaultPaginationParams(), 
      })
      this.logShowing = true
    },

    loadLogsMore() {
      this.$refs.log.loadMore({
        ...this.$refs.log.getPaginationParams(),
      })
    },
  },

  provide: function() {
    return {
      svc: this.svc,
      getDefaultPagination: this.getDefaultPagination
    }
  },

  components: {
    filters: () => import('./components/ReservedFilters.vue'),
    list: () => import('./components/ReservedList.vue'),
    actions: () => import('./components/ReservedActions.vue'),
    logs: () => import('@/app/admin/components/Log.vue'),
    logTabs: () => import('./components/ReservedLogTabs.vue'),
    typeProvider: () => import('./components/ReservedTypeProvider.vue')
  },
}
</script>

<style lang="scss" scoped>
.slots-error {
  padding: 18px;
  font-weight: bold;
}
</style>
